import React from "react";
import { t } from "../../utils/i18n";

const NotificationGroup = ({
  Settings,
  group,
  Channels,
  getSetting,
  updateSetting,
}) => {
  const accordionHeaderProps = {
    "data-toggle": "collapse",
    "aria-expanded": "true",
    "aria-controls": `${group.id}_drop`,
    "data-target": `#${group.id}_drop`,
  };

  const accordionBodyProps = {
    "aria-labelledby": `${group.id}_heading`,
    "data-parent": "#notifications_accordion",
  };

  return (
    <div className="card notification-card-reset">
      <div
        className="card-header"
        type="button"
        {...accordionHeaderProps}
        id="trades_heading"
      >
        <h6>
          <i className={`${group.icon}`} ariaHidden="true"></i>
          {group.title}
        </h6>
      </div>
      <div
        id={`${group.id}_drop`}
        className={`collapse ${group.id === "trades" && "show"}`}
        {...accordionBodyProps}
      >
        <div className="card-body">
          <div className="notification-header d-flex flex-row align-items-center">
            <div className="w-100 font-weight-bold">{t("account.notifications.type")}</div>
            <div style={{ width: "240px" }}>
              <div className="d-flex justify-content-around">
                <div className="text-center">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 48 48"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M24 2C19.6488 2 15.3953 3.29028 11.7774 5.70767C8.15957 8.12506 5.33977 11.561 3.67464 15.581C2.00952 19.6009 1.57384 24.0244 2.42272 28.292C3.27159 32.5596 5.36689 36.4796 8.44365 39.5564C11.5204 42.6331 15.4404 44.7284 19.708 45.5773C23.9756 46.4261 28.3991 45.9905 32.419 44.3253C36.439 42.6602 39.8749 39.8404 42.2923 36.2225C44.7097 32.6047 46 28.3512 46 24C45.9934 18.1673 43.6734 12.5753 39.549 8.45096C35.4247 4.32659 29.8327 2.00662 24 2V2ZM42.318 32H36.13C36.6372 29.6995 36.9189 27.3551 36.971 25H43.949C43.8361 27.4132 43.2834 29.7854 42.318 32ZM4.05099 25H11.029C11.0811 27.3551 11.3628 29.6995 11.87 32H5.68199C4.71662 29.7854 4.16388 27.4132 4.05099 25V25ZM5.68199 16H11.87C11.3628 18.3005 11.0811 20.6449 11.029 23H4.05099C4.16388 20.5868 4.71662 18.2146 5.68199 16V16ZM25 14V4.092C28.639 4.692 31.764 8.528 33.512 14H25ZM34.075 16C34.6171 18.2958 34.9188 20.6418 34.975 23H25V16H34.075ZM23 4.092V14H14.488C16.236 8.528 19.361 4.692 23 4.092ZM23 16V23H13.028C13.0842 20.6418 13.3859 18.2958 13.928 16H23ZM13.028 25H23V32H13.925C13.3839 29.7041 13.0832 27.3581 13.028 25V25ZM23 34V43.908C19.361 43.308 16.236 39.472 14.488 34H23ZM25 43.908V34H33.512C31.764 39.472 28.639 43.308 25 43.908ZM25 32V25H34.972C34.9158 27.3582 34.6141 29.7042 34.072 32H25ZM36.971 23C36.9189 20.6449 36.6372 18.3005 36.13 16H42.318C43.2834 18.2146 43.8361 20.5868 43.949 23H36.971ZM41.294 14H35.613C34.7451 10.7415 33.113 7.73679 30.852 5.235C35.2483 6.8496 38.9419 9.95006 41.294 14V14ZM17.148 5.235C14.887 7.73679 13.2549 10.7415 12.387 14H6.70599C9.05805 9.95006 12.7517 6.8496 17.148 5.235V5.235ZM6.70599 34H12.387C13.2549 37.2585 14.887 40.2632 17.148 42.765C12.7517 41.1504 9.05805 38.0499 6.70599 34V34ZM30.852 42.765C33.113 40.2632 34.7451 37.2585 35.613 34H41.294C38.9419 38.0499 35.2483 41.1504 30.852 42.765Z"
                      fill="black"
                    ></path>
                  </svg>
                  <div className="text-muted small">{t("account.notifications.web")}</div>
                </div>
                <div className="text-center">
                  <svg
                    width="24px"
                    height="24px"
                    viewBox="0 0 20 16"
                    version="1.1"
                  >
                    <title>email</title>
                    <desc>Created with Sketch.</desc>
                    <g
                      id="Icons"
                      stroke="none"
                      strokeWidth="1"
                      fill="none"
                      fillRule="evenodd"
                    >
                      <g
                        id="Outlined"
                        transform="translate(-918.000000, -1220.000000)"
                      >
                        <g
                          id="Communication"
                          transform="translate(100.000000, 1162.000000)"
                        >
                          <g
                            id="Outlined-/-Communication-/-email"
                            transform="translate(816.000000, 54.000000)"
                          >
                            <g>
                              <polygon
                                id="Path"
                                points="0 0 24 0 24 24 0 24"
                              ></polygon>
                              <path
                                d="M22,6 C22,4.9 21.1,4 20,4 L4,4 C2.9,4 2,4.9 2,6 L2,18 C2,19.1 2.9,20 4,20 L20,20 C21.1,20 22,19.1 22,18 L22,6 Z M20,6 L12,11 L4,6 L20,6 Z M20,18 L4,18 L4,8 L12,13 L20,8 L20,18 Z"
                                id="🔹-Icon-Color"
                                fill="#1D1D1D"
                              ></path>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <div className="text-muted small">{t("account.notifications.email")}</div>
                </div>
                <div className="text-center">
                  <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
                    <title></title>
                    <g id="Smartphone">
                      <path d="M21,2H11A5,5,0,0,0,6,7V25a5,5,0,0,0,5,5H21a5,5,0,0,0,5-5V7A5,5,0,0,0,21,2ZM19,4a1,1,0,0,1-1,1H14a1,1,0,0,1-1-1Zm5,21a3,3,0,0,1-3,3H11a3,3,0,0,1-3-3V7a3,3,0,0,1,3-3,3,3,0,0,0,3,3h4a3,3,0,0,0,3-3,3,3,0,0,1,3,3Z"></path>
                      <path d="M17,25H15a1,1,0,0,0,0,2h2a1,1,0,0,0,0-2Z"></path>
                    </g>
                  </svg>
                  <div className="text-muted small">{t("account.notifications.app")}</div>
                </div>
              </div>
            </div>
          </div>

          {Settings.filter((set) => set.resource.includes(group.resource)).map(
            (set) => {
              return (
                <div
                  className="notification-header d-flex flex-row align-items-center py-2 border-top "
                  key={set.id}
                >
                  <div className="w-100 pr-3">
                    {set.name}
                    <br />{" "}
                    <span className="small text-muted">{set.description} </span>
                  </div>
                  <div style={{ width: "240px" }}>
                    <div className="d-flex justify-content-around ml-5">
                      <div className="text-center">
                        <div className="custom-control custom-switch settings-switch">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`${set.id}_web`}
                            onChange={(e) =>
                              updateSetting(set.slug, "web", e.target.checked)
                            }
                            checked={getSetting(set.slug, "web")}
                          />
                          <label
                            className="custom-control-label"
                            for={`${set.id}_web`}
                          ></label>
                        </div>
                      </div>

                      <div className="text-center ml-5">
                        <div className="custom-control custom-switch settings-switch">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`${set.id}_email`}
                            onChange={(e) =>
                              updateSetting(set.slug, "email", e.target.checked)
                            }
                            checked={getSetting(set.slug, "email")}
                          />
                          <label
                            className="custom-control-label"
                            for={`${set.id}_email`}
                          ></label>
                        </div>
                      </div>
                      <div className="text-center ml-5">
                        <div className="custom-control custom-switch settings-switch">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            id={`${set.id}_app`}
                            onChange={(e) =>
                              updateSetting(set.slug, "app", e.target.checked)
                            }
                            checked={getSetting(set.slug, "app")}
                          />
                          <label
                            className="custom-control-label"
                            for={`${set.id}_app`}
                          ></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          )}
        </div>
      </div>
    </div>
  );
};

export default NotificationGroup;
